import { ExpressionFieldFilterLabel } from './ExpressionFieldFilterLabel';
import { ExpressionFieldFilterPanel } from './ExpressionFieldFilterPanel';
// @ts-expect-error untyped import
import { useFilterEdit } from '../FilterEditContext';
// @ts-expect-error untyped import
import SnowflakeFilterEditPopover from '../SnowflakeFilterEditPopover';
// @ts-expect-error untyped import
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
// @ts-expect-error untyped import
import { useExpressionField } from '../SourceMeta';
import { useGetExpressionFilterErrorTooltipMessage } from './use-get-expression-filter-error-tooltip-message';
import { useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../../../utils/filter-utils';
import { NewExpressionFieldFilterPanel } from './NewExpressionFieldFilterPanel';
import { ExpressionFieldFilterDisplayLabel } from './ExpressionFieldFilterDisplayLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpressionFieldItem = ({
  filter,
  groupIndex,
  filterIndex,
  readOnly
}) => {
  // @ts-expect-error pending migration of FilterEditContext
  const [{
    editingGroupIndex,
    editingFilterIndex
  } = {}, editCallbacks] = useFilterEdit();
  const expressionField = useExpressionField(filter.field.name);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const errorTooltipMessage = useGetExpressionFilterErrorTooltipMessage(filter);
  const showEditPanel = groupIndex === editingGroupIndex && filterIndex === editingFilterIndex;
  const isUngatedToPropertyFilterMigration = getIsUngatedToSnowflakePropertyFilterMigration(userGates);
  const FilterPanel = isUngatedToPropertyFilterMigration ? NewExpressionFieldFilterPanel : ExpressionFieldFilterPanel;
  const editPanel = /*#__PURE__*/_jsx(FilterPanel, {
    filter: filter,
    groupId: groupIndex,
    onDone: ({
      draftFilter,
      draftGroupId
    }) => editCallbacks.handleFilterChange(draftFilter, draftGroupId),
    onCloneFilter: ({
      draftFilter,
      groupId
    }) => editCallbacks.handleCloneFilterToGroup(draftFilter, groupId),
    onCancel: editCallbacks.handleCancelEdit
  });
  const LabelItem = isUngatedToPropertyFilterMigration ? ExpressionFieldFilterDisplayLabel : ExpressionFieldFilterLabel;
  return /*#__PURE__*/_jsx(SnowflakeFilterEditPopover, {
    editPanel: editPanel,
    open: showEditPanel,
    onClose: editCallbacks.handleCancelEdit,
    disabled: readOnly || !expressionField,
    children: /*#__PURE__*/_jsx(SnowflakeFilterWrapper, {
      highlighted: showEditPanel,
      onEdit: () => editCallbacks.handleFilterEdit(groupIndex, filterIndex),
      onRemove: () => editCallbacks.handleFilterRemove(groupIndex, filterIndex),
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(LabelItem, {
        errorTooltipMessage: errorTooltipMessage,
        filter: filter
      })
    })
  });
};